/**
 * Type shapes for the Avatar Generation Assistant — a guided, local-only
 * character-concept builder that pre-fills the prompt on `AvatarCreate`.
 *
 * Linear 4-step flow. State lives as plain `useState` in `AvatarAssistant.tsx`
 * (ephemeral — no Redux, no localStorage draft).
 */

export type AssistantStep = 'archetype' | 'vibe' | 'accents' | 'review';

/** The single linear path through the wizard. */
export const STEP_ORDER = ['archetype', 'vibe', 'accents', 'review'] as const;

export interface AssistantSelections {
  /** Single-select — required to leave the archetype step. */
  archetypeId?: string;
  /** Single-select — required to leave the vibe step. */
  vibeId?: string;
  /** Multi-select — optional, capped at MAX_ACCENTS (see catalog.ts). */
  accentIds: string[];
}

/**
 * A pickable option in any step.
 *
 * - `labelKey` resolves against the `avatarAssistant` i18n namespace (localized
 *   EN+IT display text).
 * - `promptFragment` is the raw ENGLISH text composed into the generation
 *   prompt — kept out of i18n on purpose (image-model quality + the qavatar-api
 *   systemPrompts are English). See the invariant comment in catalog.ts.
 */
export interface Option {
  id: string;
  labelKey: string;
  icon?: string;
  promptFragment: string;
}
